/**
 * The two marks a segmenter save control draws.
 *
 * Apart from `segmenter-save-control.ts`, which lays the control out. What a
 * mark is made of is a question about the sprite, and what the control is made
 * of is a question about the form.
 */

/**
 * The two marks, each with the box it is drawn on.
 *
 * The box is here rather than looked up, so there is no name this file has no
 * box for. Both are 448 wide because `src/assets/fa-icon-map.ts` gives both a
 * Font Awesome icon drawn on that box, and a `<use>` fits a symbol into
 * whatever viewport it is given.
 */
const marks = [
  { name: "save", box: "0 0 448 512", className: "cb-save-word-mark-save" },
  {
    name: "save-word-remove",
    box: "0 0 448 512",
    className: "cb-save-word-mark-held",
  },
] as const;

/**
 * Both marks, of which the stylesheet shows one.
 *
 * Drawing both and hiding one is what a 词典 entry does, and the rule that
 * hides the wrong one is already in `modules/save-word`. Swapping them on a
 * press would mean rebuilding an `<svg>` on every press for no gain.
 */
export function saveMarks(icons: string | undefined): readonly Node[] {
  return icons === undefined ? [] : marks.map((one) => mark(icons, one));
}

/**
 * One mark, as a reference into the sprite.
 *
 * The element carries the symbol's own view box. A `<use>` fits the symbol
 * into whatever viewport it is given, so a square box here would letterbox a
 * narrow mark. `partials/icon.html` says the rest of it.
 *
 * Decorative, because the button's `aria-label` already names the act and the
 * word.
 */
function mark(icons: string, one: (typeof marks)[number]): SVGElement {
  const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  const use = document.createElementNS("http://www.w3.org/2000/svg", "use");

  svg.setAttribute("class", `cb-icon cb-save-word-mark ${one.className}`);
  svg.setAttribute("viewBox", one.box);
  svg.setAttribute("aria-hidden", "true");
  svg.setAttribute("focusable", "false");
  use.setAttribute("href", `${icons}#${one.name}`);
  svg.append(use);

  return svg;
}
